const initialState = {
    AccountNumberOfQuestions: "",
    NumberOfCourses: "",
    AccountNumberOfEngagements: "",
    UID: "",
    userEmail: "",
    authorCreatedDate: "",
    ProfileFirstName: "",
    ProfileLastName: "",
    emailVerified: "",
    AndroidLoginBoolean: false,
    TodaysEngagements: "",
}

//We dispatched the createLecture in the lectureAction.js.  This file needs to detect the createLecture.
const AdminPanelReducer = (state = initialState, action) => {
    //detect the createLecture through the switch statements.

    switch (action.type) {

        case 'getUserContentCreation':
            return{
                ...state,
                AccountNumberOfQuestions: action.AccountNumberOfQuestions,
                UID: action.UID,
                NumberOfCourses: action.NumberOfCourses,
                AccountNumberOfEngagements: action.AccountNumberOfEngagements,
                userEmail: action.userEmail,
                authorCreatedDate: action.authorCreatedDate,
                ProfileFirstName: action.ProfileFirstName,
                ProfileLastName: action.ProfileLastName,
                emailVerified: action.emailVerified,
                AndroidLoginBoolean: action.AndroidLoginBoolean,
                TodaysEngagements: action.TodaysEngagements,

            }

        
        default:
            return state;
    }

}

export default AdminPanelReducer